module.exports = __webpack_public_path__ + "img/img2.2e6b22c.png";